import { useContext } from 'react';
import { Modal, Button } from 'antd';
import { WarningOutlined } from '@ant-design/icons';
import { KickOffContext } from './ModalKickOff';

interface ConfirmModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const ConfirmModal = ({ open, onClose, onConfirm }: ConfirmModalProps) => {
  const { currentTaxYearStr } = useContext(KickOffContext);

  return (
    <Modal
      open={open}
      onCancel={onClose}
      title="Final confirmation!"
      centered
      width={420}
      footer={[
        <Button key="cancel" onClick={onClose}>
          Cancel
        </Button>,
        <Button key="confirm" type="primary" onClick={onConfirm}>
          Proceed
        </Button>,
      ]}
    >
      <div
        style={{
          padding: 12,
          backgroundColor: '#FF9F4329',
          borderRadius: 5,
          display: 'flex',
          gap: 16,
        }}
      >
        <WarningOutlined style={{ color: '#FF9F43', fontSize: 18 }} />
        <div style={{ color: '#FF9F43' }}>
          This action is irreversible. Before you proceed, please ensure your
          final payroll for the {currentTaxYearStr} Tax Year is fully
          processed.
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmModal;
